<div class="container-fluid "   style="background-color: #d0d0d0">
    <div class="container text-center">
        <div class="row flex-column">
            <!-- Login Left -->
            <div class="text-center page-not-found-content col-sm-12">
                <h3 class="mt-4">404. This is not the webpage you are looking for.</h3>
                <a class="btn btn-default btn-lg mt-2" [routerLink]="['/login']">Go back to Login</a>
            </div>
        </div>
    </div>
</div>